/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setDoc = function setDoc(doc) {
	if (doc) {
		setDocId(doc);
		setName(doc);
	} else {
		return null;
	}
};

var setDocById = function setDocById(id) {
	if (id) {
		var doc = findDoc(id);
		setDoc(doc);
	}
};

var setName = function setName(doc) {
	if (doc) {
		var name = formatName(doc);
		$('#business-data').attr('data-doctor-name', name);
	}
};

var setDocId = function setDocId(doc) {
	if (doc && doc._id) {
		$('#business-data').attr('data-doctor-id', doc._id);
		if (window.PB) {
			window.PB.doc = doc;
		}
	}
};

var findDoc = function findDoc(id) {
	if (window.PB && window.PB.staff.length > 0) {
		return window.PB.staff.find(function (s) {
			return s._id === id;
		});
	} else {
		return null;
	}
};

var clearDoc = function clearDoc() {
	window.PB.doc = null;
};

var getDocName = function getDocName(id) {
	var doc = findDoc(id);
	if (doc) {
		return formatName(doc);
	}
	return '';
};

var formatName = function formatName(doc) {
	if (doc) {
		return doc.salutation + ' ' + doc.first_name + ' ' + doc.last_name;
	} else {
		return '';
	}
};

var getUniqueAppTimes = function getUniqueAppTimes(appArray) {
	return appArray.filter(function (obj, pos, arr) {
		return arr.map(function (mapObj) {
			return mapObj['start_time'];
		}).indexOf(obj['start_time']) === pos;
	});
};

var getAppsforCurrentDoc = function getAppsforCurrentDoc() {
	if (!window.PB.appointments) {
		return [];
	}

	var currentArray = [];
	if (!window.PB.doc) {
		currentArray = window.PB.appointments.map(function (dayArray) {
			return _extends({}, dayArray, {
				aptsArr: getUniqueAppTimes(dayArray.aptsArr)
			});
		});
	} else {
		currentArray = window.PB.appointments.map(function (dayArray) {
			return _extends({}, dayArray, {
				aptsArr: dayArray.aptsArr.filter(function (app) {
					return app.doctor_id === window.PB.doc._id;
				})
			});
		}).filter(function (day) {
			return day.aptsArr.length > 0;
		});
	}

	currentArray.forEach(function (ca) {
		var appNumber = ca.aptsArr.length;
		ca.title = appNumber > 9 ? '9+' : appNumber.toString();
	});
	return currentArray;
};

exports.setDoc = setDoc;
exports.setDocById = setDocById;
exports.findDoc = findDoc;
exports.getAppsforCurrentDoc = getAppsforCurrentDoc;
exports.getDocName = getDocName;
exports.clearDoc = clearDoc;
exports.getUniqueAppTimes = getUniqueAppTimes;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = renderConfirmationView;

function renderConfirmationView() {
  console.log('firing renderConfirmationView');
  $('#content').addClass('confirmation-view');
  $('#top').remove();
  $('#main').remove();

  var message = 'Your request has been submitted.\n' + 'You will receive an email when the appointment is confirmed.';

  var $message = $(document.createElement('div')).attr('id', 'confirmation-message').addClass('font-lg');

  $($message).html(message);
  $('#bottom').before($message);
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getOffsetTop(element) {
  var yPosition = 0;
  var nextElement = element;
  while (nextElement) {
    yPosition += nextElement.offsetTop;
    nextElement = nextElement.offsetParent;
  }
  console.log('elements y Offset: ', element, yPosition);
  return yPosition;
}

module.exports = getOffsetTop;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.submitLabel = exports.doctors = undefined;

var _dot = __webpack_require__(7);

var _dot2 = _interopRequireDefault(_dot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var doctors = _dot2.default.template('\n<div class="pb-doctors__wrapper col-12">\n\t<div class="pb-subtitle">Select a doctor</div>\n\t<select class="pb-select pb-select--doctors">\n\t\t<option value="" selected>Any</option>\n\t\t{{~it.staff :value:index}}\n\t\t<option value={{=value._id}}>{{=value.salutation}} {{=value.first_name}} {{=value.last_name}}</option>\n\t\t{{~}}\n\t</select>\n</div>\n');

var submitLabel = _dot2.default.template('\n\tRequest Appointment for {{=it.aptDate}} at {{=it.aptTime}} with {{=it.docName}}.\n');

exports.doctors = doctors;
exports.submitLabel = submitLabel;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _calMethods = __webpack_require__(5);

var _doctorMethods = __webpack_require__(0);

var _confirmationView = __webpack_require__(1);

var _confirmationView2 = _interopRequireDefault(_confirmationView);

var _doctors = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

console.log('firing main.js');

$(document).ready(function () {
  window.PB = {
    shouldFetch: true
  };
  console.log('doc ready');

  //Disables autoscroll to last position on reload
  if (history && 'scrollRestoration' in history) history.scrollRestoration = 'manual';

  //Scrolls to the top of the page to show any updates
  $(window).scrollTop(0);

  loadBusinessInfo();
  loadStaffForLocation();
});

function renderBusinessInfo(businessData) {
  if (businessData.info) {
    var _businessData$info = businessData.info,
        name = _businessData$info.name,
        mailing_address_line_1 = _businessData$info.mailing_address_line_1,
        mailing_address_city = _businessData$info.mailing_address_city,
        mailing_address_state = _businessData$info.mailing_address_state;


    var addr = mailing_address_line_1 + ', ' + mailing_address_city + ', ' + mailing_address_state;

    $('.pb-business-info__title').html(name);
    $('.pb-business-info__address').html(addr);
  } else {
    console.log('malformed data retrieved');
  }
}

function loadBusinessInfo() {
  var business_id = $('#business-data').attr('data-business-id');
  $.ajax({
    url: '/business/id/' + business_id + '/public/info',
    dataType: 'json',
    success: function success(data) {
      var businessData = JSON.parse(data);
      renderBusinessInfo(businessData);
      renderCalendarView();
    },
    error: function error(jqXHR, status, _error) {
      console.log('error retreiving business info');
      console.log('status:', status);
      console.log('error:', _error);
    }
  });
}

function loadStaffForLocation() {
  var business_id = $('#business-data').attr('data-business-id');
  var location_id = $('#business-data').attr('data-location-id');
  $.ajax({
    url: '/staff/business/' + business_id + '/location/' + location_id,
    dataType: 'json',
    success: staffLoadedCallback,
    error: function error(jqXHR, status, _error2) {
      console.log('error retreiving business info');
      console.log('status:', status);
      console.log('error:', _error2);
    }
  });
}

function staffChangeCallback() {
  var currentValue = $(this).val();
  if (currentValue === "" || currentValue === 'any') {
    $('#business-data').attr('data-doctor-id', '');
    (0, _doctorMethods.clearDoc)();
    resetEvents();
  } else {
    var doc = (0, _doctorMethods.findDoc)(currentValue);
    (0, _doctorMethods.setDoc)(doc);
    resetEvents();
  }
}

function resetEvents() {
  window.PB.shouldFetch = false;
  $('#calendar-wrapper').fullCalendar('refetchEvents');
  window.PB.shouldFetch = true;
  $('#times-wrapper').remove();
  $('#patient-info-row').remove();
}

function staffLoadedCallback(data) {
  var staffData = JSON.parse(data);
  window.PB.staff = staffData.staff;
  if (staffData.staff.length > 1) {
    $('.pb-doctors').append((0, _doctors.doctors)(staffData));
    $('.pb-select--doctors').change(staffChangeCallback);
  } else {
    var doc = staffData.staff[0];
    (0, _doctorMethods.setDoc)(doc);
  }
}

function renderCalendarView() {
  $('#calendar-wrapper').fullCalendar({
    header: {
      left: 'prev',
      center: 'title',
      right: 'next'
    },
    events: _calMethods.events, //fn to get events
    eventClick: _calMethods.eventClick, //callback when event is clicked
    viewRender: _calMethods.viewRender, //callback when new month is rendered
    showNonCurrentDates: false, //hide dates outside curr month
    fixedWeekCount: false, //show # weeks in curr month
    height: 'auto', //sets calendar height; may want to use contentHeight
    eventBackgroundColor: '#853CAF',
    eventBorderColor: '#853CAF',
    eventTextColor: 'white'
  });
  window.PB.eventSource = $('#calendar-wrapper').fullCalendar('getEventSources')[0];
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _patientView = __webpack_require__(6);

var _patientView2 = _interopRequireDefault(_patientView);

var _getOffsetTop = __webpack_require__(2);

var _getOffsetTop2 = _interopRequireDefault(_getOffsetTop);

var _doctorMethods = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  events: events,
  eventClick: eventClick,
  viewRender: viewRender,
  createCalendarEvents: createCalendarEvents

  //Fetches appointment data from web server when calendar loads or changes view
  //Formats data for use in calendar rendering
};function events(start, end, timezone, callback) {
  if (window.PB.appointments && !window.PB.shouldFetch) {
    callback((0, _doctorMethods.getAppsforCurrentDoc)());
  } else {
    console.log('fetching apt data');
    var business_id = $('#business-data').attr('data-business-id');
    var location_id = $('#business-data').attr('data-location-id');
    var doctor_id = $('#business-data').attr('data-doctor-id');

    var data = {
      start: start.format('YYYY-MM-DD'),
      end: end.format('YYYY-MM-DD')
    };

    if (doctor_id !== '') {
      data.doctor_id = doctor_id;
    }

    $.ajax({
      url: '/appointments/business_id/' + business_id + '/location_id/' + location_id,
      dataType: 'json',
      data: data,
      success: function success(data) {
        window.PB.fetchedData = JSON.parse(data);
        var aptsArr = createAppointments(data);
        window.PB.appointments = aptsArr;
        callback((0, _doctorMethods.getAppsforCurrentDoc)());
      },
      error: function error(jqXHR, status, _error) {
        console.log('error fetching apt data');
        console.log('status:', status);
        console.log('error:', _error);
      }
    });
  }
}

function createAppointments(eventData) {
  var parsed = JSON.parse(eventData);
  var aptsByDoctors = parsed.available_times;
  var aptsArr = formatDoctorApps(aptsByDoctors);

  return createCalendarEvents(aptsArr);
}

//events -- Called when web server returns json event data
function createCalendarEvents(aptsArr) {
  var sortedAptsObj = sortAptsByDay(aptsArr);
  var calendarEventsArr = formatRenderedEvents(sortedAptsObj);
  return calendarEventsArr;
}

function formatDoctorApps(aptsByDoctors) {
  var mappedArray = [];

  var _loop = function _loop(i) {
    aptsByDoctors[i].mappedApps = aptsByDoctors[i].time_intervals.map(function (int) {
      return _extends({}, int, { doctor_id: aptsByDoctors[i].doctor_id });
    });
    mappedArray = mappedArray.concat(aptsByDoctors[i].mappedApps);
  };

  for (var i = 0; i < aptsByDoctors.length; i++) {
    _loop(i);
  }
  return mappedArray;
}

//events -- Creates an object which categorizes appointments by day
function sortAptsByDay(aptsArr) {
  var sortedApts = {};

  aptsArr.forEach(function (aptObj) {
    var day = moment.parseZone(aptObj.start_time).format('YYYY-MM-DD');
    if (sortedApts[day]) sortedApts[day].push(aptObj);else sortedApts[day] = [aptObj];
  });

  return sortedApts;
}

//events -- Formats events so calendar can interpret them
function formatRenderedEvents(sortedObj) {
  var renderedEvents = [];
  for (var day in sortedObj) {
    var len = (0, _doctorMethods.getUniqueAppTimes)(sortedObj[day]).length;
    var title = len > 9 ? '9+' : len.toString();
    renderedEvents.push({
      title: title,
      allDay: true,
      start: moment.parseZone(sortedObj[day][0].start_time),

      aptsArr: sortedObj[day]
    });
  }
  return renderedEvents;
}

//Called when an event is clicked ********************************************
function eventClick(event, jsEvent, view) {
  //Delete Existing Patient View (if one exists) to prevent duplicates
  $('#patient-info-row').remove();

  $('.selected-button').removeClass('selected-button');
  $(this).addClass('selected-button');

  //Render time section if not rendered already
  var $timesContainer = $('#times-container');
  if ($timesContainer.has('#times-wrapper').length === 0) {
    var $timesWrapper = $(document.createElement('div')).attr('id', 'times-wrapper').addClass('col-12');

    var _$timesTitle = $(document.createElement('h2')).attr('id', 'times-title').addClass('pb-subtitle col-12');

    var _$timesList = $(document.createElement('div')).attr('id', 'times-list').addClass('row no-gutters');

    $timesWrapper.append(_$timesTitle, _$timesList);
    $timesContainer.append($timesWrapper);
  };

  var $timesTitle = $('#times-title');
  var $timesList = $('#times-list');
  var renderDate = moment.parseZone(event.aptsArr[0].start_time).format('dddd, MMMM Do YYYY');
  $timesTitle.html(renderDate);

  if ($timesList.has('.time-button').length !== 0) {
    $timesList.empty();
    $timesList.scrollTop(0);
  }

  // append appointments
  event.aptsArr.forEach(function (apt, idx) {

    $timesList.append($aptButton(apt));
  });

  //Scroll to List of Appointment Times
  if (window.innerWidth < 576) {
    setTimeout(function () {
      var target = (0, _getOffsetTop2.default)(document.querySelector('#times-wrapper'));
      $('#content').animate({
        scrollTop: target
      }, 600);
    }, 100);
  } else {
    $('html, body').animate({
      scrollTop: $('#times-wrapper').offset().top
    }, 600);
  }
}

function $aptButton(apt) {
  var renderedTime = moment.parseZone(apt.start_time).format('h:mm a');
  var $btnContainer = $(document.createElement('div')).addClass('col-6 col-sm-4 pb-btn-container');
  var $button = $(document.createElement('button')).addClass('purple-button sec-button time-button ').html(renderedTime).click(function () {
    $('.time-button.selected-button').removeClass('selected-button');
    $button.addClass('selected-button');
    (0, _doctorMethods.setDocById)(apt.doctor_id);
    (0, _patientView2.default)(apt);
  });
  $btnContainer.append($button);
  return $btnContainer;
}

//Called when a new calendar view is rendered
function viewRender(view, element) {
  $('#times-wrapper').remove();
  $('#patient-info-row').remove();

  //Disable navigating to view past months
  var today = moment();
  if (today > view.start && today < view.end) {
    $(".fc-prev-button").prop('disabled', true);
    $(".fc-prev-button").addClass('fc-state-disabled');
  } else {
    $(".fc-prev-button").removeClass('fc-state-disabled');
    $(".fc-prev-button").prop('disabled', false);
  }
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _confirmationView = __webpack_require__(1);

var _confirmationView2 = _interopRequireDefault(_confirmationView);

var _getOffsetTop = __webpack_require__(2);

var _getOffsetTop2 = _interopRequireDefault(_getOffsetTop);

var _doctorMethods = __webpack_require__(0);

var _doctors = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = renderPatientView;

function getAptData(aptObj) {
  var aptDate = moment.parseZone(aptObj.start_time).format('dddd, MMMM Do YYYY');
  var aptTime = moment.parseZone(aptObj.start_time).format('h:mm a');
  var docName = (0, _doctorMethods.getDocName)(aptObj.doctor_id);
  return { aptDate: aptDate, aptTime: aptTime, docName: docName };
}

function updateAptDate(aptObj) {
  var aptData = getAptData(aptObj);
  $('#submit-button-label').html((0, _doctors.submitLabel)(aptData));
}

function createPatientForm(aptObj) {
  var aptData = getAptData(aptObj);
  //Wrappers for Patient Info Section
  var $patientInfoRow = $(document.createElement('div')).attr('id', 'patient-info-row').addClass('row');
  var $patientInfoWrapper = $(document.createElement('div')).attr('id', 'patient-info-wrapper').addClass('col-12 centered-wrapper');
  var $patientInfoHeader = $(document.createElement('div')).addClass('col-12 pb-title').html('Patient Information').attr('id', 'patient-info-header');

  var $form = $(document.createElement('form')).attr('id', 'patient-info-form').addClass('font-md').attr('action', '/book').attr('method', 'post').attr('novalidate', 'novalidate');

  //******Input Elements and Labels in Form******

  //First Name
  var $firstNameLabel = $(document.createElement('label')).attr('id', 'first-name-label').attr('for', 'first-name').html('First Name:');
  var $firstName = $(document.createElement('input')).attr('id', 'first-name').attr('name', 'firstName').attr('type', 'text').prop('required', true).attr('placeholder', 'First Name');
  var $firstNameWrapper = $wrapper('first-name-wrapper', $firstNameLabel, $star(), $br(), $firstName);

  //Last Name
  var $lastNameLabel = $(document.createElement('label')).attr('id', 'last-name-label').attr('for', 'last-name').html('Last Name:');
  var $lastName = $(document.createElement('input')).attr('id', 'last-name').attr('name', 'lastName').attr('type', 'text').prop('required', true).attr('placeholder', 'Last Name');
  var $lastNameWrapper = $wrapper('last-name-wrapper', $lastNameLabel, $star(), $br(), $lastName);

  //Phone Number
  var $phoneNumberLabel = $(document.createElement('label')).attr('id', 'phone-number-label').attr('for', 'phone-number').html('Primary Phone Number:');
  var $phoneNumber = $(document.createElement('input')).attr('id', 'phone-number').attr('name', 'phoneNumber').attr('type', 'tel').prop('required', true).attr('placeholder', '888-123-4567').on('change keyup paste', formatPhoneNumber).attr('pattern', '^([0-9]{3})-([0-9]{3})-([0-9]{4})$');
  var $phoneNumberWrapper = $wrapper('phone-number-wrapper', $phoneNumberLabel, $star(), $br(), $phoneNumber);

  //Email Address
  var $emailLabel = $(document.createElement('label')).attr('id', 'email-label').attr('for', 'email').html('Email Address:');
  var $email = $(document.createElement('input')).attr('id', 'email').attr('name', 'email').attr('type', 'email').prop('required', true).attr('placeholder', 'someone@example.com');
  var $emailWrapper = $wrapper('email-wrapper', $emailLabel, $star(), $br(), $email);

  // DOB
  var $dobLabel = $(document.createElement('label')).attr('id', 'dob-label').attr('for', 'dob').html('Date of Birth:');
  var $dob = $(document.createElement('input')).attr('id', 'dob').attr('name', 'dob').attr('type', 'text').attr('placeholder', '01/31/1973');
  var $dobWrapper = $wrapper('dob-wrapper', $dobLabel, $br(), $dob);

  //Current Patient? (y/n)
  var $currentPatientLabel = $(document.createElement('label')).attr('id', 'current-patient-label').attr('for', 'current-patient').html('Are you a current patient?');
  var $currentPatient = $(document.createElement('select')).attr('id', 'current-patient').attr('name', 'currentPatient').prop('required', true);
  var $currentPatientYes = $(document.createElement('option')).attr('value', 'Yes').html('Yes');
  var $currentPatientNo = $(document.createElement('option')).attr('value', 'No').html('No');

  $currentPatient.append($(document.createElement('option')), $currentPatientYes, $currentPatientNo);

  var $currentPatientWrapper = $wrapper('current-patient-wrapper', $currentPatientLabel, $star(), $br(), $currentPatient);

  //Reason for Appointment
  var $reasonLabel = $(document.createElement('label')).attr('id', 'reason-label').attr('for', 'reason').html('What is the reason for your appointment?');
  var $reason = $(document.createElement('select')).attr('id', 'reason').attr('name', 'reason').prop('required', true);
  var $reason1 = $(document.createElement('option')).attr('value', 'Vision and eye health exam for glasses wearer').html('Vision and eye health exam for glasses wearer');
  var $reason2 = $(document.createElement('option')).attr('value', 'Vision and eye health exam for contact and glasses wearer').html('Vision and eye health exam for contact and glasses wearer');
  var $reason3 = $(document.createElement('option')).attr('value', 'Dry eye evaluation').html('Dry eye evaluation');
  var $reason4 = $(document.createElement('option')).attr('value', 'Medical concern').html('Medical concern');
  var $reason5 = $(document.createElement('option')).attr('value', 'Other').html('Other');

  $reason.append($(document.createElement('option')), $reason1, $reason2, $reason3, $reason4, $reason5);

  var $reasonWrapper = $wrapper('reason-wrapper', $reasonLabel, $star(), $br(), $reason);

  //Type of Insurance
  var $insuranceLabel = $(document.createElement('label')).attr('id', 'insurance-label').attr('for', 'insurance').html('What kind of insurance do you have?');
  var $insurance = $(document.createElement('select')).attr('id', 'insurance').attr('name', 'insurance').prop('required', true);
  var $insurance1 = $(document.createElement('option')).attr('value', 'None').html('None');
  var $insurance2 = $(document.createElement('option')).attr('value', 'VSP').html('VSP');
  var $insurance3 = $(document.createElement('option')).attr('value', 'EyeMed').html('EyeMed');
  var $insurance4 = $(document.createElement('option')).attr('value', 'Spectera').html('Spectera');
  var $insurance5 = $(document.createElement('option')).attr('value', 'Other').html('Other');

  $insurance.append($insurance1, $insurance2, $insurance3, $insurance4, $insurance5);

  var $insuranceWrapper = $wrapper('insurance-wrapper', $insuranceLabel, $star(), $br(), $insurance);

  // Insurance Member ID
  var $insuranceMemberIDLabel = $(document.createElement('label')).attr('id', 'insurance-member-id-label').attr('for', 'insurance-member-id').html('Insurance Member ID:');
  var $insuranceMemberID = $(document.createElement('input')).attr('id', 'insurance-member-id').attr('name', 'insuranceMemberID').attr('placeholder', '12345678');
  var $insuranceMemberIDWrapper = $wrapper('insurance-member-id-wrapper', $insuranceMemberIDLabel, $br(), $insuranceMemberID);

  //Appointment Concerns/Notes
  var $concernsLabel = $(document.createElement('label')).attr('id', 'concerns-label').attr('for', 'concerns').html('What concerns, if any, would you like to speak to the doctor about:');
  var $concerns = $(document.createElement('textarea')).attr('id', 'concerns').attr('name', 'concerns').attr('form', 'patient-info-form');
  var $concernsWrapper = $wrapper('concerns-wrapper', $concernsLabel, $br(), $concerns);

  //Submit Button
  var $submitButtonWrapper = $(document.createElement('div')).addClass('centered-wrapper').attr('id', 'submit-button-wrapper');
  var $submitButtonLabel = $(document.createElement('label')).attr('id', 'submit-button-label').html((0, _doctors.submitLabel)(aptData));
  var $submitButton = $(document.createElement('input')).attr('type', 'submit').attr('id', 'submit-button').addClass('purple-button main-button').attr('value', 'REQUEST');
  $submitButtonWrapper.append($submitButtonLabel, $br(), $submitButton);

  //Append Visible Elements
  $form.append($firstNameWrapper, $lastNameWrapper, $phoneNumberWrapper, $emailWrapper, $dobWrapper, $currentPatientWrapper, $reasonWrapper, $insuranceWrapper, $insuranceMemberIDWrapper, $concernsWrapper, $submitButtonWrapper);

  //Hidden Inputs Obtained from Appointment Object
  var $startTime = $(document.createElement('input')).attr('name', 'startTime').attr('value', aptObj.start_time).attr('hidden', true);
  var $endTime = $(document.createElement('input')).attr('name', 'endTime').attr('value', aptObj.end_time).attr('hidden', true);

  //Append Hidden Elements
  $form.append($startTime, $endTime);

  //Attach Submit Event Listener;
  $form.submit(submitForm);

  //Attach form to Page
  $patientInfoRow.append($patientInfoWrapper);
  $patientInfoWrapper.append($patientInfoHeader, $form);
  $('#main').append($patientInfoRow);
}

function renderPatientView(aptObj) {
  var aptDate = moment.parseZone(aptObj.start_time).format('dddd, MMMM Do YYYY');
  var aptTime = moment.parseZone(aptObj.start_time).format('h:mm a');

  //Delete Existing Patient View (if one exists) to prevent duplicates
  if ($('#patient-info-row').length > 0) {
    updateAptDate(aptObj);
  } else {
    createPatientForm(aptObj);
  }

  var $patientInfoRow = document.querySelector('#patient-info-row');

  //Scroll to Patient Info Section
  if (window.innerWidth < 576) {
    var target = (0, _getOffsetTop2.default)($patientInfoRow);
    $('#content').animate({
      scrollTop: target
    }, 600);
  } else {
    $('html, body').animate({
      scrollTop: $($patientInfoRow).offset().top
    }, 600);
  }
}

//Helper Functions to Create Repeated Elements
function $br() {
  return $(document.createElement('br'));
}

function $star() {
  return $(document.createElement('span')).addClass('star').html(' *');
}

function $wrapper(id) {
  var output = $(document.createElement('div')).addClass('input-wrapper').attr('id', id);

  for (var _len = arguments.length, elements = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    elements[_key - 1] = arguments[_key];
  }

  output.append.apply(output, elements);
  return output;
}

//Formats the Phone Number Input Field
function formatPhoneNumber(event) {
  var output = void 0;
  var input = $("#phone-number").val();
  input = input.replace(/[^0-9]/g, '');
  var area = input.substr(0, 3);
  var pre = input.substr(3, 3);
  var tel = input.substr(6, 4);
  if (area.length < 3) {
    output = area;
  } else if (area.length == 3 && pre.length >= 0 && pre.length < 3) {
    output = area + '-' + pre;
  } else if (area.length == 3 && pre.length == 3) {
    output = area + '-' + pre + '-' + tel;
  }

  var charCode = event.which ? event.which : event.keyCode;
  var isBackSpace = charCode === 8;
  if (isBackSpace && output.charAt(output.length - 1) === '-') {
    output = output.substring(0, output.length - 1);
  }

  $("#phone-number").val(output);
};

function checkForm() {
  var inputs = document.querySelector('#patient-info-form').elements;
  for (var i = 0; i < inputs.length; i++) {
    if (!inputs[i].validity.valid) {
      var $errorMsg = $(document.createElement('div')).addClass('pb-error-msg');

      if (inputs[i].validity.valueMissing) {
        $errorMsg.html('This field is required');
      } else {
        switch (inputs[i].name) {
          case 'email':
            $errorMsg.html('Please enter a valid email address.');
            break;
          case 'phoneNumber':
            $errorMsg.html('Please enter a valid phone number.');
            break;
          default:
            $errorMsg.html('The information you have entered is not valid.');
        }
      }

      $(inputs[i]).parent().addClass('error').append($errorMsg);
    }
  }

  var isValid = document.querySelector('#patient-info-form').checkValidity();
  return isValid;
}

function clearErrors() {
  $('.pb-error-msg').remove();
  $('.input-wrapper.error').removeClass('error');
}

//Triggered when the for is submitted
function submitForm(e) {
  e.preventDefault();

  clearErrors();

  //Formats object to be send to server with form data
  var formData = $(e.target).serializeArray().reduce(function (accum, curr) {
    accum[curr.name] = curr.value;
    return accum;
  }, {});

  var isValid = checkForm();

  if (!isValid) {
    return false;
  }

  formData.phoneNumber = formData.phoneNumber.replace(/[^0-9]/g, '');
  formData.doctor_id = window.PB.doc._id;
  var business_id = $('#business-data').attr('data-business-id');
  var location_id = $('#business-data').attr('data-location-id');

  $.ajax({
    url: '/book/business_id/' + business_id + '/location_id/' + location_id,
    type: 'POST',
    data: formData,
    success: function success(data) {
      (0, _confirmationView2.default)();
    },
    error: function error(err) {
      console.log('error during submitting form');
      $('#submit-button').removeClass('disabled');
      $('#submit-button').prop('disabled', false);
    }
  });

  $('#submit-button').addClass('disabled');
  $('#submit-button').prop('disabled', true);
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// doT.js
// 2011-2014, Laura Doktorova, https://github.com/olado/doT
// Licensed under the MIT license.

(function () {
	"use strict";

	var doT = {
		name: "doT",
		version: "1.1.1",
		templateSettings: {
			evaluate:    /\{\{([\s\S]+?(\}?)+)\}\}/g,
			interpolate: /\{\{=([\s\S]+?)\}\}/g,
			encode:      /\{\{!([\s\S]+?)\}\}/g,
			use:         /\{\{#([\s\S]+?)\}\}/g,
			useParams:   /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
			define:      /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
			defineParams:/^\s*([\w$]+):([\s\S]+)/,
			conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
			iterate:     /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
			varname:	"it",
			strip:		true,
			append:		true,
			selfcontained: false,
			doNotSkipEncoded: false
		},
		template: undefined, //fn, compile template
		compile:  undefined, //fn, for express
		log: true
	}, _globals;

	doT.encodeHTMLSource = function(doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	};

	_globals = (function(){ return this || (0,eval)("this"); }());

	/* istanbul ignore else */
	if (typeof module !== "undefined" && module.exports) {
		module.exports = doT;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return doT;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		_globals.doT = doT;
	}

	var startend = {
		append: { start: "'+(",      end: ")+'",      startencode: "'+encodeHTML(" },
		split:  { start: "';out+=(", end: ");out+='", startencode: "';out+=encodeHTML(" }
	}, skip = /$^/;

	function resolveDefs(c, block, def) {
		return ((typeof block === "string") ? block : block.toString())
		.replace(c.define || skip, function(m, code, assign, value) {
			if (code.indexOf("def.") === 0) {
				code = code.substring(4);
			}
			if (!(code in def)) {
				if (assign === ":") {
					if (c.defineParams) value.replace(c.defineParams, function(m, param, v) {
						def[code] = {arg: param, text: v};
					});
					if (!(code in def)) def[code]= value;
				} else {
					new Function("def", "def['"+code+"']=" + value)(def);
				}
			}
			return "";
		})
		.replace(c.use || skip, function(m, code) {
			if (c.useParams) code = code.replace(c.useParams, function(m, s, d, param) {
				if (def[d] && def[d].arg && param) {
					var rw = (d+":"+param).replace(/'|\\/g, "_");
					def.__exp = def.__exp || {};
					def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"), "$1" + param + "$2");
					return s + "def.__exp['"+rw+"']";
				}
			});
			var v = new Function("def", "return " + code)(def);
			return v ? resolveDefs(c, v, def) : v;
		});
	}

	function unescape(code) {
		return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
	}

	doT.template = function(tmpl, c, def) {
		c = c || doT.templateSettings;
		var cse = c.append ? startend.append : startend.split, needhtmlencode, sid = 0, indv,
			str  = (c.use || c.define) ? resolveDefs(c, tmpl, def || {}) : tmpl;

		str = ("var out='" + (c.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ")
					.replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""): str)
			.replace(/'|\\/g, "\\$&")
			.replace(c.interpolate || skip, function(m, code) {
				return cse.start + unescape(code) + cse.end;
			})
			.replace(c.encode || skip, function(m, code) {
				needhtmlencode = true;
				return cse.startencode + unescape(code) + cse.end;
			})
			.replace(c.conditional || skip, function(m, elsecase, code) {
				return elsecase ?
					(code ? "';}else if(" + unescape(code) + "){out+='" : "';}else{out+='") :
					(code ? "';if(" + unescape(code) + "){out+='" : "';}out+='");
			})
			.replace(c.iterate || skip, function(m, iterate, vname, iname) {
				if (!iterate) return "';} } out+='";
				sid+=1; indv=iname || "i"+sid; iterate=unescape(iterate);
				return "';var arr"+sid+"="+iterate+";if(arr"+sid+"){var "+vname+","+indv+"=-1,l"+sid+"=arr"+sid+".length-1;while("+indv+"<l"+sid+"){"
					+vname+"=arr"+sid+"["+indv+"+=1];out+='";
			})
			.replace(c.evaluate || skip, function(m, code) {
				return "';" + unescape(code) + "out+='";
			})
			+ "';return out;")
			.replace(/\n/g, "\\n").replace(/\t/g, '\\t').replace(/\r/g, "\\r")
			.replace(/(\s|;|\}|^|\{)out\+='';/g, '$1').replace(/\+''/g, "");
			//.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');

		if (needhtmlencode) {
			if (!c.selfcontained && _globals && !_globals._encodeHTML) _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
			str = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : ("
				+ doT.encodeHTMLSource.toString() + "(" + (c.doNotSkipEncoded || '') + "));"
				+ str;
		}
		try {
			return new Function(c.varname, str);
		} catch (e) {
			/* istanbul ignore else */
			if (typeof console !== "undefined") console.log("Could not create a template function: " + str);
			throw e;
		}
	};

	doT.compile = function(tmpl, def) {
		return doT.template(tmpl, null, def);
	};
}());


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.bundle.js